import { AppShellViewModel } from "../viewmodels/AppShellViewModel.js";
import { useSingleton } from "mvc-kit/react";
//#region src/modules/AppWrapper2/hooks/useMapboxToken.ts
function useMapboxToken() {
	return useSingleton(AppShellViewModel).state.mapboxToken;
}
//#endregion
export { useMapboxToken };

//# sourceMappingURL=useMapboxToken.js.map